import { Navigation } from "lucide-react";

import { BaseService } from "../../Base/BaseService";
import { MasonryItem } from "./MasonryGrid";

export interface IMasonryPostItem {
  id: number;
  title: string;
  imageUrl: string;

  distanceText?: string | null;
}

interface MasonryPostCardProps {
  item: IMasonryPostItem;
  onClick: () => void;

  className?: string;

  showDistance?: boolean;

  loading?: "eager" | "lazy";
}

const joinClassNames = (...classNames: Array<string | undefined | false>) => {
  return classNames.filter(Boolean).join(" ");
};

const getShortDistanceText = (distanceText?: string | null) => {
  return distanceText?.replace(/\s+от вас$/i, "").trim() ?? "";
};

export const MasonryPostCard = ({ item, onClick, className, showDistance = false, loading = "lazy" }: MasonryPostCardProps) => {
  const distanceText = showDistance ? getShortDistanceText(item.distanceText) : "";

  return (
    <MasonryItem>
      <button type="button" className={joinClassNames("masonry-post-card", className)} onClick={onClick} aria-label={item.title}>
        <img src={BaseService.GetFileUrl(item.imageUrl)} alt={item.title} loading={loading} decoding="async" />

        {distanceText && (
          <span className="masonry-post-card-distance">
            <Navigation size={13} />

            <span>{distanceText}</span>
          </span>
        )}
      </button>
    </MasonryItem>
  );
};
